import React, { useEffect, useState } from 'react';

import { Box } from '@mui/material';

interface Props {
  activeTab: string;
  children: React.ReactNode;
  tab: string;
}

export default function LazyContentTabPanel({ activeTab, children, tab }: Props) {
  const isActive = activeTab === tab;
  const [hasBeenActive, setHasBeenActive] = useState(isActive);

  useEffect(() => {
    if (isActive) {
      setHasBeenActive(true);
    }
  }, [isActive]);

  if (!isActive && !hasBeenActive) {
    return null;
  }

  return (
    <Box role="tabpanel" hidden={!isActive}>
      {children}
    </Box>
  );
}
